import React, { useState, useEffect } from 'react';
import ProfessionalListMobile from './professionalListMobile';
import ProfessionalListWeb from './professionalListWeb';

const useWindowWidth = () => {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowWidth;
};

const ProfessionalListRouter = () => {
  const width = useWindowWidth();
  const MOBILE_BREAKPOINT = 768;

  return width < MOBILE_BREAKPOINT ? <ProfessionalListMobile /> : <ProfessionalListWeb />;
};

export default ProfessionalListRouter;
